import { jsxs as e, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as i } from "./index.es2359.js";
function t({ size: l = i }) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { y: "0.468262", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M28.4544 32.1047C30.4627 32.1047 32.0907 30.4767 32.0907 28.4684C32.0907 26.4601 30.4627 24.832 28.4544 24.832C26.4461 24.832 24.818 26.4601 24.818 28.4684C24.818 30.4767 26.4461 32.1047 28.4544 32.1047Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C("path", { d: "M16.4545 26.2866L13 29.7412H19.9091L16.4545 26.2866Z", fill: "#E1E2FF" }),
        /* @__PURE__ */ C("path", { d: "M40.0906 30.5594L43.5451 27.1049H36.636L40.0906 30.5594Z", fill: "#E1E2FF" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M27.0673 16.9637C27.3409 16.9264 27.5325 16.6744 27.4951 16.4008C27.4578 16.1272 27.2058 15.9356 26.9322 15.9729C22.7653 16.5411 19.1747 19.1897 17.2846 22.7809C17.156 23.0252 17.2498 23.3276 17.4942 23.4562C17.7385 23.5848 18.0409 23.491 18.1695 23.2466C19.9157 19.9288 23.2342 17.4864 27.0673 16.9637Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M29.4133 16.4022C29.4498 16.1285 29.7013 15.9362 29.975 15.9727C35.5384 16.7145 40.0088 21.0874 40.8994 26.6047H43.5451C43.7473 26.6047 43.9297 26.7266 44.007 26.9134C44.0844 27.1002 44.0417 27.3153 43.8987 27.4583L40.4441 30.9128C40.2489 31.1081 39.9323 31.1081 39.737 30.9128L36.2825 27.4583C36.1395 27.3153 36.0967 27.1002 36.1741 26.9134C36.2515 26.7266 36.4338 26.6047 36.636 26.6047H39.8853C39.0052 21.5971 34.9143 17.6401 29.8428 16.9639C29.5691 16.9274 29.3768 16.676 29.4133 16.4022ZM37.8431 27.6047L40.0906 29.8522L42.338 27.6047H37.8431Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.0077 30.241H19.9091C20.1113 30.241 20.2936 30.1192 20.371 29.9324C20.4484 29.7455 20.4056 29.5305 20.2626 29.3875L16.8081 25.9329C16.6128 25.7377 16.2963 25.7377 16.101 25.9329L12.6465 29.3875C12.5035 29.5305 12.4607 29.7455 12.5381 29.9324C12.6155 30.1192 12.7978 30.241 13 30.241H15.9949C16.8509 35.8011 21.3397 40.218 26.9337 40.9638C27.2074 41.0003 27.4589 40.808 27.4954 40.5343C27.5318 40.2606 27.3395 40.0091 27.0658 39.9726C21.9638 39.2923 17.8542 35.2916 17.0077 30.241ZM18.702 29.241H14.2071L16.4546 26.9936L18.702 29.241Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M39.311 33.4739C39.559 33.5955 39.6614 33.8951 39.5398 34.143C37.6868 37.9217 34.1537 40.5858 29.8623 40.9663C29.5873 40.9907 29.3445 40.7875 29.3201 40.5124C29.2957 40.2374 29.499 39.9946 29.774 39.9702C33.6854 39.6234 36.9285 37.1967 38.642 33.7027C38.7635 33.4548 39.0631 33.3523 39.311 33.4739Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.4544 24.332C26.1699 24.332 24.318 26.1839 24.318 28.4684C24.318 30.7528 26.1699 32.6047 28.4544 32.6047C30.7388 32.6047 32.5907 30.7528 32.5907 28.4684C32.5907 26.1839 30.7388 24.332 28.4544 24.332ZM25.318 28.4684C25.318 26.7362 26.7222 25.332 28.4544 25.332C30.1865 25.332 31.5907 26.7362 31.5907 28.4684C31.5907 30.2005 30.1865 31.6047 28.4544 31.6047C26.7222 31.6047 25.318 30.2005 25.318 28.4684Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
t.__tags = [];
export {
  t as MetricVisitFrequencyIcon
};
//# sourceMappingURL=index.es414.js.map
